
const doctorInfo = {
    english: [
        {
            groupId: 0,
            groupName: 'Acupuncturists (TCM)',
            members: [
                {
                    id: 0,
                    name: "Michael Han",
                    title: "Doctor of Traditional Chinese Medicine\nNearly 30 Years of Clinical Experience\nRegistered Acupuncturist & Traditional Chinese Medicine Practitioner in British Columbia",
                    description: "Acupuncture · Acupressure · Tui Na · Chinese Herbal Medicine\n\nAreas of Focus\nPain Management — Acute & Chronic Pain · Sports Injuries · Neurological Symptoms · Insomnia & Fatigue · Headaches · Digestive Health · Chronic & Persistent Constipation · Complex Chronic Conditions\n\nExtensive experience in healthy aging, cardiovascular health, and chronic conditions in older adults."
                },
                {
                    id: 1,
                    name: "Nian Ru Li",
                    title: "Registered Acupuncturist (R.Ac.)",
                    description: "Nian Ru Li (Lu'lu) is an experienced acupuncturist who graduated from Central College, BC. With training in acupuncture, acupressure, and Tui Na, she takes a personalized approach to care, helping clients manage pain, relieve stress and tension, improve sleep, and support overall well-being.\n\nAreas of Focus\nPain Relief · Sports Injuries · Neck & Shoulder Issues · Frozen Shoulder · Headaches & Migraines · Sleep Concerns · Stress & Fatigue · Menstrual Cramps · Menopausal Support"
                }
            ]
        },
        {
            groupId: 2,
            groupName: 'Body Worker',
            members: [
                {
                    id: 2,
                    name: "Amy D",
                    title: "Body Worker",
                    description: "Body worker offering relaxation and therapeutic bodywork treatments at Canadian Han TCM Clinic."
                }
            ]
        }
    ],
    chinese: [
        {
            groupId: 0,
            groupName: '针灸师（TCM）',
            members: [
                {
                    id: 0,
                    name: "Michael Han",
                    title: "加拿大BC省注册中医师、针灸师, 中医学博士",
                    description: "加拿大BC省注册中医师、针灸师。中医学博士，上海中医药大学教授，硕士研究生导师；中医方剂学等教学、科研及临床近30年。国家中医药管理局第四批中医优才。上海中医药大学附属曙光医院传统中医科门诊专家；上海市浦东新区中医医院门诊专家；上海市安济中医医院门诊专家。曾主持国家自然基金和上海市教委基金等项目。擅长中药治疗心血管、脾胃等内科杂病，及妇科、儿科等杂症；并针灸、推拿、理筋正骨。"
                },
                {
                    id: 1,
                    name: "Nian Ru Li（Lu'lu）",
                    title: "针灸师",
                    description: "毕业于 Central College of BC，拥有多年推拿及临床调理经验。擅长运用针灸与推拿等传统中医调理方法，帮助改善各种常见疼痛及身体不适。\n\n专业领域包括：\n· 各类疼痛及肌肉骨骼问题\n· 小儿常见健康问题及体质调理\n· 女性备孕及产后身体调理\n· 更年期综合调理\n\n注重根据每个人的体质与具体情况制定个性化调理方案，帮助身体恢复平衡，提升整体健康状态。"
                }
            ]
        },
        {
            groupId: 2,
            groupName: 'Body Worker',
            members: [
                {
                    id: 2,
                    name: "Amy D",
                    title: "Body Worker",
                    description: "加拿大汉中医诊所 Body Worker，提供放松性及调理性身体护理服务。"
                }
            ]
        }
    ]
}

export default doctorInfo;
